module.exports = __webpack_public_path__ + "70446454510988fdfb2056ad2caa7065.jpg";